import { Routes } from '@angular/router';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { FARM_CONFIG } from './base/farm-configs';

/**
 * 농원 전용 라우팅
 *
 * mrhst 통합 라우팅과 독립적으로 동작.
 * FARM_CONFIG.routePath 경로로 등록.
 */
export const farmRoutes: Routes = [
  {
    path: FARM_CONFIG.routePath,
    canActivate: [permissionGuard('FARM_GOODS$READ')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/farm-list-page/farm-list-page.component'
          ).then((m) => m.FarmListPageComponent),
        data: {
          config: FARM_CONFIG,
          title: '농원',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/farm-detail-page/farm-detail-page.component'
              ).then((m) => m.FarmDetailPageComponent),
            data: {
              config: FARM_CONFIG,
              title: '농원 상세',
            },
          },
        ],
      },
    ],
  },
];
